export const ALL_DRIVERS = [
  "Weather effect",
  "Vessel performance",
  "Change in speed instructions",
  "Deviation",
  "Hull condition",
  "Change in load port stay",
  "Change in discharge port stay",
  "Force majeure",
  "Holds condition",
  "Owners/Master Performance",
  "Inaccurate estimate",
  "Intake change",
  "Canal transits",
  "Hire impact",
  "Bunker/Emissions costs",
  "Deliver/Redelivery bunker variances",
  "Market hire/bunker impact",
  "Freight reprice",
  "Change in Port Costs",
  "Dispute Provision",
];

export const DRIVER_DEFINITIONS: Record<string, string> = {
  "Weather effect":
    "Hire and bunker variances due to actual versus estimated weather effect at sea. Note: this does not need to be definitive; it is a flag for Commercial to review with the Performance team the WF recommendations.",
  "Vessel performance":
    "Time and bunker variances: gain/loss at sea due to actual versus planned speed/consumption, port consumption, etc. Underperformance to be reported only if confirmed by the Performance team, reports, etc.",
  "Change in speed instructions":
    "Time and bunker gain/loss at sea due to change in speed instructions, including speed cost recharges.",
  Deviation: "Hire and bunker variances due to deviation outside voyage optionality.",
  "Hull condition":
    "Time loss from deviation, port stay, or at sea, where easily identifiable; bunker loss on the same basis; and additional costs for survey, cleaning, etc., plus other consequences related to hull condition, including UWHI/C delay/costs and deviation.",
  "Change in load port stay":
    "Variance in dem/disp versus hire and bunkers due to rate differences, bad weather, etc. Highlight detention or other outliers, including delays not offset by off-hire.",
  "Change in discharge port stay":
    "Variance in dem/disp versus hire and bunkers due to rate differences, bad weather, etc. Highlight detention or other outliers, including delays not offset by off-hire.",
  "Force majeure": "Specific reason to be stated and kept separate from the above (e.g., strike, FM, etc.).",
  "Holds condition":
    "Consequences related to holds condition, such as time loss from rejection, deviation for cleaning and maintenance, third-party labour costs (virtual port captaincy, shore cleaning gangs, etc.), and maintenance costs such as chemicals, paint, etc.",
  "Owners/Master Performance":
    "Time, bunker, or other gain/loss due to additional and unforeseen vessel restrictions, ballast system issues, navigational or loading-sequence mistakes, or other off-hire. This includes cases of over-drafted vessels.",
  "Inaccurate estimate":
    "Variances related to incorrect estimation by Trading and/or TA, e.g., intake change, freight, hire, etc.",
  "Intake change": "Gain/loss on freight due to change in quantity, change in contract quantity, etc.",
  "Canal transits": "Time, port costs, and other variances caused by canal transits.",
  "Hire impact": "Impact of changes in hire rate and hire duration.",
  "Bunker/Emissions costs":
    "Variances due to bunker price changes, FuelEU, EU ETS, and bunker port calls, including time, port costs, etc.",
  "Deliver/Redelivery bunker variances":
    "BOD/BOR quantity or price variance, triggered when the last TCI is ticked.",
  "Market hire/bunker impact": "Flexi hire impact and flexi bunker impact.",
  "Freight reprice":
    "All related items-freight, hire, bunkers, port costs, etc.-linked to new voyage instructions from charterers.",
  "Change in Port Costs":
    "FDA to Estimate DA variances; do not include here additional port costs linked with ad hoc services such as hold or hull cleaning.",
  "Dispute Provision":
    "All provision taken to manage risk for drop of claims, such as offhire, bunkers, laytime, etc. Explain only revenue provisions.",
};

export const getDriverDefinition = (driverName: string) => DRIVER_DEFINITIONS[driverName] ?? "";
